import { CORE_API_HOSTNAME } from '../../env';

import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { colors, distances, border } from '../../styles/constants';
import Card from '../../components/Card';
import { H3, Muted } from '../../components/Typography';
import { DraftOrder, Order } from '../../types/orders';
import fulfill from '../../fulfill';
import Hr from '../../components/Hr';
export interface ExternalLinksProps extends WithTranslation {
    draftOrOrder: DraftOrder | Order;
    accountId: string;
}

const getLinks = (draftOrOrder: DraftOrder | Order) => {
    if ((draftOrOrder as DraftOrder).order) {
        return (draftOrOrder as DraftOrder).order.external_links || [];
    }
    if (draftOrOrder as Order) {
        return (draftOrOrder as Order).external_links || [];
    }
    return [];
};

const openPrivateWithIdToken = (link: {href: string; public?: boolean}, accountId: string) => (e: React.MouseEvent) => {
    if (link.public || link.public === undefined) {
        return;
    }
    e.preventDefault();
    fulfill
        .post<{ redirect_uri: string }>({
            url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/auth/redirect`,
            accountId,
            headers: {
                accept: 'application/json',
            },
            json: {
                redirect_uri: link.href,
            },
            handlers: {
                200: (res) => window.open(res.redirect_uri, '_blank'),
            },
        })
        .catch((_) => {});
};

const ExternalLinks = (
    {
        t,
        draftOrOrder,
        accountId,
    }: ExternalLinksProps
) => {
    const links = getLinks(draftOrOrder);
    if (links.length === 0) {
        return null;
    }
    return (
        <Card marginBottom={distances.normal}>
            <H3>{t('orders.fields.external_links.header')}</H3>
            <Hr />

            {links.map((link, i) => (
                <Flex key={i}>
                    <StyledExternalLink href={link.href} target="_blank" onClick={openPrivateWithIdToken(link, accountId)}>
                        <span>{link.text}</span>
                        <sup>↗</sup>
                        <em>{link.href}</em>
                    </StyledExternalLink>
                    <LinkType>
                        {link.public
                            ? t('orders.fields.external_links.public')
                            : t('orders.fields.external_links.private')}
                    </LinkType>
                </Flex>
            ))}
        </Card>
    );
};

export default withTranslation()(ExternalLinks);



const Flex = styled.div`
    display: flex;
    justify-content: space-between;
    &:last-child {
        margin-bottom: 0;
    }
    > span {
        white-space: nowrap;
    }
`;
const LinkType = styled(Muted)`
    padding: ${distances.tiny} 0;
`;

const StyledExternalLink = styled.a`
    width: 90%;
    color: ${colors.primary};
    text-decoration: none;
    padding: ${distances.tiny} 0;
    display: flex;
    white-space: nowrap;

    & > span {
        text-decoration: underline;
    }

    & > em {
        /* display: none; */
        margin-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${colors.borderDark};
        white-space: nowrap;
    }
    &:hover > em {
        /* display: inline-block; */
    }

    &:hover {
        color: ${colors.primaryHover};
        background-color: ${colors.interactiveBackgroundHover};
    }
    & > sup {
        text-decoration: none;
        font-size: 10px;
    }
`;
